document.addEventListener('DOMContentLoaded', () => {
  const productsJsonElement = document.getElementById('wavar-product-json');
  const data = JSON.parse(productsJsonElement.textContent);
  const pageUrl = data.pageUrl;
  
  const iOsQuickLookSupport = navigator.userAgent.match(/(iPhone|iPod|iPad)/i);
  const androidSupport = navigator.userAgent.match(/(Android)/i);
  let params = new URL(window.location.href).searchParams;
  let activateAR = params.get('wav'); // "AR view"

  if (iOsQuickLookSupport !== null) {
    const quickLookButtons = document.getElementsByClassName("cm-activate-ios-quick-look");
    for (const btn of quickLookButtons) {
      btn.style.setProperty("display", "flex", "important")
    }
    // activate AR on devices
    if (activateAR=="ar") document.getElementById(`cmActivateQuickLook-${wavBlockId}`).click();
  } else
  if (androidSupport !== null) {
    const sceneViewerButtons = document.getElementsByClassName("cm-activate-android-scene-viewer")
    for (const btn of sceneViewerButtons) {
      btn.style.setProperty("display", "flex", "important")
    }
    // activate AR on devices
    if (activateAR=="ar") document.getElementById(`cmActivateSceneViewer-${wavBlockId}`).click();
  } else {
    const showQrCodeButtons = document.getElementsByClassName("cm-show-qr-code-desktop")
    for (const btn of showQrCodeButtons) {
      btn.style.setProperty("display", "flex", "important")
    }
    // Generate QR Code for product page
    if (document.querySelector(".cm-qr-code").childElementCount !== 0) {
        document.querySelector(".cm-qr-code").innerHTML = "";
    }
    new QRCode(document.querySelector(".cm-qr-code"), {
        text: `${pageUrl}`,
        width: 180, //default 128
        height: 180,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
    });
  }
});

function cmActivateArQuickLook(event) {
  // workaround for iOS Quicklook; test defer
  event.stopPropagation();
  
  const iOsQuickLookBtn = document.getElementById(`cmActivateQuickLook-${wavBlockId}`);
  const el = document.createElement('a');
  el.setAttribute('hidden', 'true');
  el.setAttribute('rel', 'ar');
  el.setAttribute('href', iOsQuickLookBtn.getAttribute('data-href'));
  el.innerHTML = `<img src="{{ 'cartmagician-icon-eye@2x.png' | asset_url }}">`;
  el.addEventListener('click', (event) => {event.stopImmediatePropagation();} )
  document.body.appendChild(el);

  el.click();
}

